<div class="breadcrumb">
    <div class="container">
        <a routerLink="/">Home</a> > {{ 'Lista de grupos' | translate}}
    </div>
</div>

<main class="container">
    <h1 i18n>{{ 'Lista de grupos' | translate}}</h1>

    <div class="flex space-between filtros">
        <div class="filtros">
            <div class="filtro">
                <label for="cboGrupo" i18n>{{ 'Grupos' | translate}}</label>
                <select id="cboGrupo" [(ngModel)]="filtro.grupo" (change)="atualizaFiltro()">
                    <option value="" i18n>{{ 'Todos' | translate}}</option>
                    <option *ngFor="let grupo of listaGrupos" [value]="grupo.id">{{grupo.name}}</option>
                </select>
            </div>    
            <div class="filtro">
                <label for="cboPais" i18n>{{ 'País' | translate}}</label>
                <select id="cboPais" [(ngModel)]="filtro.pais" (change)="atualizaFiltro()">
                    <option value="" i18n>{{ 'Todos' | translate}}</option>
                    <option *ngFor="let pais of listaPaises" [value]="pais.id">{{pais.name}}</option>
                </select>
            </div>    
            <div class="filtro">
                <label for="status" i18n>{{ 'Região' | translate}}</label>
                <select id="status" [(ngModel)]="filtro.regiao" (change)="atualizaFiltro()">
                    <option value="" i18n>{{ 'Todos' | translate}}</option>
                    <option *ngFor="let status of listaRegiao" [value]="status.id">{{status.name}}</option>
                </select>
            </div>
            <div class="filtro">
                <label for="cboUsuario" i18n>{{ 'Usuário' | translate}}</label>
                <select id="cboUsuario" [(ngModel)]="filtro.usuario" (change)="atualizaFiltro()">
                    <option value="" i18n>{{ 'Todos' | translate}}</option>
                    <option *ngFor="let usuario of listaUsuarios" [value]="usuario.id">{{usuario.email}}</option>
                </select>
            </div>    
            <div class="filtro">
                <label for="search" i18n>{{ 'Pesquisar por nome' | translate}}</label>
                <input type="text" id="search" [(ngModel)]="filtro.search" (keyup)="atualizaFiltro()">
            </div>

            <div class="filtro">
                <label i18n>{{ 'Limpar filtros' | translate}}</label>
                <button (click)="limparFiltro()" class="red_button" i18n>{{ 'Limpar' | translate}}</button>
            </div>
        </div>
        
        <div class="add_group_button filtro">
            <label i18n>&nbsp;</label>
            <button (click)="novoGrupo()" class="red_button" *ngIf="showButtonNovoGrupo" i18n>{{ 'Adicionar grupo' | translate}}</button>
            <!-- <button (click)="showAddGroup = !showAddGroup" class="red_button" i18n *ngIf="!showAddGroup">{{ 'Adicionar grupo' | translate}}</button>
            <button (click)="showAddGroup = !showAddGroup" class="red_button" i18n *ngIf="showAddGroup">{{ 'Fechar' | translate}}</button> -->
        </div>
    </div>

    <div hidden class="add_group" *ngIf="showAddGroup">
        <h2 i18n>{{ 'Criar um grupo' | translate}}:</h2>
        <div class="flex form filtros">
            <div class="form-group filtro">
                <label for="group-select" i18n>{{ 'Grupo' | translate}}:</label>
                <select id="group-select" class="form-control" [(ngModel)]="selectedGroupId">
                    <option value="new" i18n>{{ 'Criar novo grupo' | translate}}</option>
                    <option *ngFor="let group of listaItens" [value]="group.id">{{group.name}}</option>
                </select>
            </div>
            <div class="form-group filtro" *ngIf="selectedGroupId === 'new'">
                <label for="grupo" i18n>{{ 'Nome do novo grupo' | translate}}:</label>
                <input type="text" class="form-control" id="grupo" [(ngModel)]="groupName">
            </div>
            <div class="form-group filtro">
                <label for="grupo" i18n>{{ 'Volume' | translate}} %:</label>
                <input type="number" class="form-control" id="grupo" [(ngModel)]="groupPeso" appNumeroDe1a100>
            </div>
            <div class="form-group filtro">
                <label for="pais" i18n>{{ 'País' | translate}}:</label>
                <select class="form-control" id="pais" [(ngModel)]="paisSelecionado" (change)="carregarListaRegiao()">
                <option value="" disabled selected i18n>{{ 'Selecione um País' | translate}}</option>
                <option *ngFor="let pais of listaPaises" [value]="pais.id">{{pais.name}}</option>
                </select>
            </div>
            <div class="form-group filtro">
                <label for="usuario" i18n>{{ 'Região' | translate}}:</label>
                <select class="form-control" id="usuario" [(ngModel)]="regiaoSelecionada">
                <!-- <option value="" disabled selected i18n>{{ 'Selecione uma região' | translate}}</option> -->
                <option value="" selected i18n>{{ 'Todos' | translate}}</option>
                <option *ngFor="let regiao of listaRegiao" [value]="regiao.id">{{regiao.name}}</option>
                </select>
            </div>
            <div class="form-group filtro">
                <label i18n>&nbsp;</label>
                <button class="red_button" (click)="adicionarGrupo()" i18n>{{ 'Adicionar' | translate}}</button>
            </div>
        </div>
    </div>

    <div class="bulk-actions" *ngIf="someSelected">
        <span>{{ selectedIds.length }} {{ 'selecionado(s)' | translate }}</span>
        <button class="red_button" (click)="desativarSelecionados()">{{ 'Desativar selecionados' | translate }}</button>
        <button class="light_button" (click)="limparSelecao()">{{ 'Cancelar' | translate }}</button>
    </div>

    <table border="0" cellpadding="0" cellspacing="0">
        <thead>
            <tr>
                <th><input type="checkbox" [checked]="allSelected" (change)="toggleSelectAll()"></th>
                <th i18n>{{ 'Grupo' | translate}}</th>
                <th i18n>{{ 'País' | translate}}</th>
                <th i18n>{{ 'Região' | translate}}</th>
                <th i18n>{{ 'Volume' | translate}} %</th>
                <th i18n>{{ 'Qtd usuários' | translate}}</th>
                <th i18n>{{ 'Ações' | translate}}</th>
            </tr>
        </thead>
        <tbody>
            <tr [ngClass]="{'red-bold': item.weightSum < 100, 'inactive-row': item.isActive === false, 'selected-row': selectedMap[item.idGrupoRegion]}" *ngFor="let item of flatList | paginate: { itemsPerPage: 15, currentPage: currentPage }; let i = index">
                <td (click)="$event.stopPropagation()">
                    <input *ngIf="item.isActive !== false" type="checkbox"
                        [checked]="!!selectedMap[item.idGrupoRegion]"
                        (change)="onToggleItem(item.idGrupoRegion, $any($event.target).checked)">
                </td>
                <td><a (click)="editarGrupo(item.idGrupo, item.idGrupoRegion); $event.stopPropagation();" class="" title="{{ 'Ver detalhes' | translate}}" style="cursor: pointer; color: blue; text-decoration: underline;">
                        {{item.name}}
                    </a>
                </td>
                <td>{{item.country}}</td>
                <td>{{item.region}}</td>
                <td>{{item.weight}}</td>
                <td>{{item.userMembers}}</td>
                <td>
                    <a *ngIf="item.isActive !== false" (click)="toggleActiveGroupCountryRegion(item); $event.stopPropagation();" class="dark_button btn-toggle-active" title="{{ 'Desativar associação' | translate}}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
                    </a>
                    <a *ngIf="item.isActive === false" (click)="toggleActiveGroupCountryRegion(item); $event.stopPropagation();" class="light_button btn-toggle-active" title="{{ 'Reativar associação' | translate}}">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="16"/><line x1="8" y1="12" x2="16" y2="12"/></svg>
                    </a>
                </td>
            </tr>
        </tbody>
    </table>

    <div class="text-center pagination">
        <div class="pagination-controls">
            <pagination-controls (pageChange)="currentPage = $event" previousLabel="" nextLabel=""></pagination-controls>
        </div>
        <!--div class="pagination-info">
            <span>{{ 'Página' | translate}}</span> {{currentPage}} <span i18n>{{ 'de' | translate}}</span> {{arredondar(listaShowItens.length / 15)}} - {{ 'total de itens' | translate}}: {{totalItems}}
        </div-->
    </div>

    <div class="loader-container" *ngIf="loading">
        <div class="spinner"></div>
        <p i18n>{{ 'Carregando' | translate}}...</p>
    </div>
</main>